import { MaxWidthContainer } from 'components/city-blocks/max-width-container';
import { UnderlineButton } from 'components/dynamic-content/button';
import React from 'react';

interface IProps {
  className?: string;
  children: React.ReactNode;
  title: React.ReactNode | string;
  seeAllHref?: string;
  seeAllText?: string;
}

export const AllLinksSection: React.FC<IProps> = ({
  className,
  title,
  children,
  seeAllHref,
  seeAllText = 'See all',
}) => (
  <MaxWidthContainer className={className}>
    <div className='mb-8 flex flex-col gap-6 md:mb-16 md:gap-8'>
      <div className='flex w-full flex-row items-start justify-between gap-4'>
        <div className='flex flex-col items-start justify-start'>
          <div className='text-red-950 leading-trim-both text-edge-cap justify-start text-xl font-bold leading-[120%] sm:text-2xl md:text-3xl'>
            {title}
          </div>
        </div>
        {seeAllHref && (
          <div className='flex w-36 flex-col items-end justify-end'>
            <UnderlineButton link={seeAllHref} text={seeAllText} className='w-fit' underlineWidth='48' />
          </div>
        )}
      </div>
      <div className='grid w-full grid-cols-2 gap-3 md:flex md:flex-wrap md:gap-4'>{children}</div>
    </div>
  </MaxWidthContainer>
);
